"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign_out_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const local_storage_names_1 = require("../../../../constants/local_storage_names");
const user_1 = require("../user");
const authHelpers_1 = require("../../../../firebase/authHelpers");
exports.sign_out_thunk = (0, toolkit_1.createAsyncThunk)("user/thunks/sign_out_thunk", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    localStorage.removeItem(local_storage_names_1.USER_LOCAL_STORAGE);
    localStorage.removeItem(local_storage_names_1.HERO_CONNECT_USER_LOCAL_STORAGE);
    localStorage.removeItem("return-to");
    yield (0, authHelpers_1.signOutFirebase)();
    // Unset the state.
    dispatch((0, user_1.setUser)({
        user: {
            _id: "",
            email: "",
            cell_number: "",
            password: "",
            confirm_password: "",
            name: "",
            surname: "",
            reset_password_otp: undefined,
            remember_me: true,
            facetecDBRef: null,
        },
        token: "",
        isLoading: false,
        newRegistration: false,
        faceTecAuthorized: false,
    }));
    dispatch((0, user_1.setIsLoading)(false));
}));
